import { merchantApi } from '@/config/axios'
import type { OrgActResult, OrgItem } from './org'

/** 机构端控制台：发码 / 入驻审 / 派单（B 端商家 token → merchant-api） */

export interface JoinItem {
  joinId: string
  phone: string
  orgId: string
  inviteCodeUsed?: string
  status: string
  rejectReason?: string
}

export interface OrgApplyOpenForm {
  name: string
  city: string
  licenseNo: string
  licenseUrl: string
  legalPerson: string
  idCardFront: string
  idCardBack: string
  contactPhone: string
  contactEmail?: string
  loginUsername: string
  loginPassword: string
  confirmPassword: string
}

const BASE = '/merchant-api/capacity/org-console'

/** 公开完整入驻（可未登录） */
export const orgApplyOpen = (data: OrgApplyOpenForm) =>
  merchantApi.post<OrgActResult>({ url: `${BASE}/apply/open`, data })

/** 商家提交运力机构入驻平台申请（已登录简版） */
export const orgApply = (data: { name: string; city: string; contactPhone: string }) =>
  merchantApi.post<OrgActResult>({ url: `${BASE}/apply`, data })

/** 查询本人申请/绑定状态 */
export const orgMyApply = () => merchantApi.get<OrgItem | null>({ url: `${BASE}/apply` })

export const orgInvite = (orgId: string) =>
  merchantApi.get<OrgItem>({ url: `${BASE}/invite`, params: { orgId } })

export const orgRotateInvite = (orgId: string) =>
  merchantApi.post<OrgActResult>({ url: `${BASE}/invite/rotate`, params: { orgId } })

export const orgJoins = (orgId: string, pendingOnly = false) =>
  merchantApi.get<JoinItem[]>({ url: `${BASE}/joins`, params: { orgId, pendingOnly } })

export const orgDecideJoin = (data: {
  orgId: string
  joinId: string
  decision: 'approve' | 'reject'
  reason?: string
}) => merchantApi.post<OrgActResult>({ url: `${BASE}/joins/decide`, data })

export const orgOfferDispatch = (waybillId: string) =>
  merchantApi.post<OrgActResult>({ url: `${BASE}/dispatch/offer`, data: { waybillId } })

export const orgOfferBroadcast = (waybillId: string) =>
  merchantApi.post<OrgActResult>({ url: `${BASE}/dispatch/offer-broadcast`, data: { waybillId } })

export type { OrgActResult, OrgItem }
